// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610142323/js/" + chunkId + "." + {"44":"cca1da5e","225":"0609f37c","481":"56f6436d","486":"35f3d200","770":"5712483b"}[chunkId] + ".0.23109616756533247.chunk.js";
};